/** Stamped by the dropdown singleton on every panel it renders; holds the entry id. */
export const DROPDOWN_PANEL_SELECTOR = '[data-dropdown-id]';

/** The dropdown panel `node` was rendered into, or null when it sits outside every panel. */
export function closestDropdownPanel(node: Node | null): HTMLElement | null {
  const element = node instanceof Element ? node : (node?.parentElement ?? null);
  return element?.closest<HTMLElement>(DROPDOWN_PANEL_SELECTOR) ?? null;
}
